'use client';

import { NoopType } from '@/ts/types';
import { useState } from 'react';

export interface IUseToggleReturnHook {
  toggle: NoopType;
  toggled: boolean;
  toggleOn: NoopType;
  toggleOff: NoopType;
  reassignValue: (flag: boolean) => void;
}

interface IOptions {
  initialValue?: boolean;
  toggleCb?: (flag: boolean) => void;
  toggleOffCb?: NoopType;
  toggleOnCb?: NoopType;
}

export type UseToggle = (options?: IOptions) => IUseToggleReturnHook;

export const useToggle: UseToggle = (options) => {
  const { initialValue = false, toggleCb, toggleOffCb, toggleOnCb } = options ?? {};
  const [toggled, setToggled] = useState(initialValue);

  const toggle = () => {
    setToggled((t) => {
      const flag = !t;
      toggleCb?.(flag);
      if (flag) {
        toggleOnCb?.();
      } else {
        toggleOffCb?.();
      }
      return flag;
    });
  };

  const toggleOn = () => {
    setToggled(true);
    toggleOnCb?.();
  };
  const toggleOff = () => {
    setToggled(false);
    toggleOffCb?.();
  };

  const reassignValue = (flag: boolean) => setToggled(flag);
  return {
    toggled,
    toggle,
    toggleOff,
    toggleOn,
    reassignValue,
  };
};
